import React from 'react';
import * as RT from '../../../constants/Routing.js'
import LoadingGif from '../../../lib/images/loading.gif'
import { Redirect } from 'react-router-dom'
import CommunityHeader from '../CommunityHead'
import { Link } from 'react-router-dom'
import Modal from '../../App/Modal'
import ReactDOM from 'react-dom'
import defaultUserThumb from '../../../lib/images/user-thumb-default.png'

export default class Component extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      openModal: false,
      needReloadCommunity: false,
      ownerChangeMode: false
    }
  }

  componentWillUnmount = () => {
    this.props.communityAllReset()
  }

  userApprove = (communityId, user) => {
    this.setState({ [`openApproveModal-${user.id}`]: false, needReloadCommunity: true})
    this.props.communityUserApprove(communityId, user.id)
  }

  userReject = (communityId, user) => {
    this.setState({ [`openRejectModal-${user.id}`]: false, needReloadCommunity: true })
    this.props.communityUserReject(communityId, user.id)
  }

  componentWillUpdate = (nextProps) => {
    if (nextProps.Community.destroyed) {
      const { history } = this.props
      history.push(RT.USER_MYPAGE_PATH)
    } else {
      if (this.state.needReloadCommunity) {
        this.props.communityGet(this.props.match.params.id)
        this.props.communityGetApplied(this.props.match.params.id)
        this.setState({needReloadCommunity: false})
      } else {

        let state = {}
        let updateBool = false
        if (this.props.Community.appliedUsers !== nextProps.Community.appliedUsers) {
          if (nextProps.Community.appliedUsers) {

            nextProps.Community.appliedUsers.map(user => {
              state[`openApproveModal-${user.id}`] = false
            })
            updateBool = true
          }
        }
        if (!this.props.Community.community && nextProps.Community.community) {
          if (nextProps.Community.community.members) {
            nextProps.Community.community.members.map(user => {
              state[`openBlockModal-${user.id}`] = false
              state[`openOwnerChangeModal-${user.id}`] = false
            })
            updateBool = true
          }
        }

        if (updateBool) {
          this.setState(state)
        }
      }

      
    }
    
  }

  openModal = () => {
    this.setState({openModal: true})
  }

  closeModal = () => {
    this.setState({openModal: false})
  }

  toOwnerChangeMode = () => {
    this.setState({ownerChangeMode: true})
  }

  removeOwnerChangeMode = () => {
    this.setState({ownerChangeMode: false})
  }

  destroyCommunity = (id) => {
    this.closeModal()
    this.props.communityDestroy(id)
  }

  userBlock = (communityId, user) => {
    this.setState({ [`openBlockModal-${user.id}`]: false, needReloadCommunity: true })
    this.props.communityUserBlock(communityId, user.id)
  }

  ownerChange = (communityId, user) => {
    this.setState({ [`openOwnerChangeModal-${user.id}`]: false, needReloadCommunity: true, ownerChangeMode: false })
    this.props.ownerChange(communityId, user.id)
  }

  componentWillMount = () => {
    if (!this.props.Community.community || Number(this.props.Community.community.id) !== Number(this.props.match.params.id)) {
      this.props.communityGet(this.props.match.params.id)
    }
  }

  componentWillUnmount = () => {
    this.props.communityGetAppliedReset()
  }

  componentDidUpdate = () => {
    const selectedCommunity = this.props.Community.community
    if (selectedCommunity && selectedCommunity.approval && !this.props.Community.appliedLoad) {
      this.props.communityGetApplied(selectedCommunity.id)
    }
  }
  

  render = () => {
    const currentUser = this.props.App.currentUser
    const selectedCommunity = this.props.Community.community
    const currentPath = this.props.currentPath

    if (selectedCommunity) {

      const modal = (
        <Modal
          okClickHandler={() => this.destroyCommunity(selectedCommunity.id)}
          headerTitle='サークルを削除します。'
          isOpen={this.state.openModal}
          closeModal={this.closeModal}
          okText='解散する'
        >
          <p>一度解散したサークルは元に戻せません。</p>
          <p>本当に解散してよろしいですか？</p>
        </Modal>
      )


      const approvalCircle = selectedCommunity.approval

      let appliedBody, appliedUsersCount = 0, approvedUsers, approvedUsersCount = 0, membersTitle = '参加中のユーザー', approvedUsersBody,
        zeroApprovedUsersText = '参加中のユーザーはいません'
      if (approvalCircle) {
        if (this.props.Community.appliedLoad) {
          const appliedUser = this.props.Community.appliedUsers
          if (appliedUser && appliedUser.length > 0) {
            appliedBody = appliedUser.map(user => {
              const photo = user.photo || defaultUserThumb
              const userPath = RT.USER_SHOW_PATH.replace(/:id/, user.id)
              let gender
              switch (user.gender) {
                case 'male':
                  gender = '男性'
                  break;
                case 'female':
                  gender = '女性'
                  break;
                default:
                  gender = '性別不明'
                  break;
              }

              const modal = (
                <Modal
                  okClickHandler={() => this.userApprove(selectedCommunity.id, user)}
                  headerTitle={`${user.name} さんの参加を承認しますか？`}
                  isOpen={this.state[`openApproveModal-${user.id}`]}
                  closeModal={() => { this.setState({ [`openApproveModal-${user.id}`]: false }) }}
                  okText='承認する'
                >
                  <p>このサークルへの参加を承認してよろしいですか？</p>
                </Modal>
              )

              const rejectmodal = (
                <Modal
                  okClickHandler={() => this.userReject(selectedCommunity.id, user)}
                  headerTitle={`${user.name} さんの参加を拒否しますか？`}
                  isOpen={this.state[`openRejectModal-${user.id}`]}
                  closeModal={() => { this.setState({ [`openRejectModal-${user.id}`]: false }) }}
                  okText='拒否する'
                >
                  <p>このサークルへの参加を拒否してよろしいですか？</p>
                </Modal>
              )

              return (
                <div className='col-12' key={user.id}>
                  {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
                  {ReactDOM.createPortal(rejectmodal, document.getElementById('dialogSpace'))}
                  <div className='appliedUserItem'>
                    <Link to={userPath}>
                      <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
                    </Link>
                    <Link to={userPath}>
                      <p>{user.name} ({user.age}/{gender})</p>
                    </Link>
                    <div className='small appliedUserActions'>
                      <Link to={userPath} className='btn btn-xs btn-white small'>詳細</Link>
                      <span className='btn btn-primary small' onClick={() => { this.setState({ [`openApproveModal-${user.id}`]: true})}}>承認</span>
                      <span onClick={() => {
                        this.setState({ [`openRejectModal-${user.id}`]: true})
                      }} className='btn btn-danger small'>非承認</span>
                    </div>
                  </div>
                </div>
              )
            })
            appliedUsersCount = appliedUser.length
          } else {
            appliedBody = (
              <div className='col-12'>
                <p className='alert alert-info'>
                  参加申請中のユーザーはいません
              </p>
              </div>
            )
          }
        } else {
          appliedBody = (
            <div className='col-12'>
              <p className='alert alert-light'>
                <img src={LoadingGif} alt='' className='loading-img' />
              </p>
            </div>
          )
        }

        membersTitle = '承認済みのユーザー'
        zeroApprovedUsersText = '承認済みのユーザーはいません'
      }

      approvedUsers = selectedCommunity.members
      approvedUsersCount = approvedUsers.length
      if (approvedUsers && approvedUsers.length > 0) {
        approvedUsersBody = approvedUsers.map(user => {
          const photo = user.photo || defaultUserThumb
          const userPath = RT.USER_SHOW_PATH.replace(/:id/, user.id)
          let gender
          switch (user.gender) {
            case 'male':
              gender = '男性'
              break;
            case 'female':
              gender = '女性'
              break;
            default:
              gender = '性別不明'
              break;
          }
          const modal = (
            <Modal
              okClickHandler={() => this.userBlock(selectedCommunity.id, user)}
              headerTitle={`${user.name} さんをブロックします`}
              isOpen={this.state[`openBlockModal-${user.id}`]}
              closeModal={() => { this.setState({ [`openBlockModal-${user.id}`]: false }) }}
              okText='ブロックする'
            >
              <p>{user.name}さんをこのサークルから強制的に退会させます。</p>
              <p>本当にブロックしてよろしいですか？</p>
            </Modal>
          )
          return (
            <div className='col-12' key={user.id}>
              {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
              <div className='appliedUserItem'>
                <Link to={userPath}>
                  <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
                </Link>
                <Link to={userPath}>
                  <p>{user.name} ({user.age}/{gender})</p>
                </Link>
                <div className='small appliedUserActions'>
                  <Link to={userPath} className='btn btn-xs btn-white small'>詳細</Link>
                  <span className='btn btn-danger small' onClick={() => { this.setState({ [`openBlockModal-${user.id}`]: true }) }}>ブロック</span>
                </div>
              </div>
            </div>
          )

        })
      } else {
        approvedUsersBody = (
          <div className='col-12'>
            <p className='alert alert-info'>
              {zeroApprovedUsersText}
            </p>
          </div>
        )
      }
      
      let menuBody
      if (this.state.ownerChangeMode) {
        if (approvedUsers && approvedUsers.length > 0) {
          const ownerChangeUsers = approvedUsers.map(user => {
            const photo = user.photo || defaultUserThumb
            const userPath = RT.USER_SHOW_PATH.replace(/:id/, user.id)
            let gender
            switch (user.gender) {
              case 'male':
                gender = '男性'
                break;
              case 'female':
                gender = '女性'
                break;
              default:
                gender = '性別不明'
                break;
            }
            const modal = (
              <Modal
                okClickHandler={() => this.ownerChange(selectedCommunity.id, user)}
                headerTitle='管理者を変更します'
                isOpen={this.state[`openOwnerChangeModal-${user.id}`]}
                closeModal={() => { this.setState({ [`openOwnerChangeModal-${user.id}`]: false }) }}
                okText='変更する'
              >
                <p>管理者に新たになるためには銀行口座情報が承認されている必要があります。</p>
                <p>{user.name}さんをこのサークルの管理者に変更してよろしいですか？</p>
              </Modal>
            )
            return (
              <div className='col-12' key={user.id}>
                {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
                <div className='appliedUserItem'>
                  <Link to={userPath}>
                    <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
                  </Link>
                  <Link to={userPath}>
                    <p>{user.name} ({user.age}/{gender})</p>
                  </Link>
                  <div className='small appliedUserActions'>
                    <Link to={userPath} className='btn btn-xs btn-white small'>詳細</Link>
                    <span className='btn btn-danger small' onClick={() => { this.setState({ [`openOwnerChangeModal-${user.id}`]: true }) }}>確認</span>
                  </div>
                </div>
              </div>
            )
          })
          menuBody = (
            <div className='pc-container'>
              <h2 className='sub-headline small text-left'>■新たに選任したい管理者を選んで下さい</h2>
              <div className='row'>
                {ownerChangeUsers}
              </div>
              <span className='btn btn-submit btn-block' onClick={this.removeOwnerChangeMode}>戻る</span>
            </div>

          )
        } else {
          menuBody = (
            <div className='pc-container'>
              <h2 className='sub-headline small text-left'>■新たに選任したい管理者を選んで下さい</h2>
              <p className='alert alert-info'>
                管理者に選べるメンバーがいません。
              </p>
              <span className='btn btn-submit btn-block' onClick={this.removeOwnerChangeMode}>戻る</span>
            </div>

          )
        }

      } else {
        menuBody = (
          <div className='pc-container'>
            <h2 className='sub-headline small text-left'>■管理メニュー</h2>
            <div className='row'>
              <div className='col-6 mb-3'>
                <Link to={RT.COMMUNITY_PATH.replace(/:id/, selectedCommunity.id)} className='btn btn-white btn-block'>詳細</Link>
              </div>
              <div className='col-6 mb-3'>
                <Link to={RT.COMMUNITY_EDIT_PATH.replace(/:id/, selectedCommunity.id)} className='btn btn-warning btn-block'>編集</Link>
              </div>
              <div className='col-6 mb-3'>
                <span className='btn btn-danger btn-block' onClick={this.openModal}>解散</span>
              </div>
              <div className='col-6 mb-3'>
                <span className='btn btn-danger btn-block' onClick={this.toOwnerChangeMode}>管理者を変更</span>
              </div>
            </div>
            {(() => {
              if (approvalCircle) {
                return (
                  <div className='row'>
                    <div className='col-12'>
                      <h2 className='sub-headline small text-left'>■未承認の参加申請 ({appliedUsersCount})</h2>
                    </div>
                    {appliedBody}
                  </div>
                )
              }
            })()}
            <h2 className='sub-headline small text-left'>■{membersTitle} ({approvedUsersCount})</h2>
            <div className='row'>
              {approvedUsersBody}
            </div>
          </div>
        )
      }

      return (
        <section className='circleShow'>
          {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
          <CommunityHeader currentUser={currentUser} currentPath={currentPath} circle={selectedCommunity} openModal={this.openModal} manageMode={true} />
          {menuBody}
        </section>
      )
    } else {
      return (
        <section className='container'>
          <img src={LoadingGif} alt='' className='loading-img' />
        </section>
      )
    }

  }
}


// WEBPACK FOOTER //
// ./src/components/Community/Manage/Manage.jsx